import { useMemo } from "react";
import { BarChart } from "@ui-component-library";
import Skeleton from "../../comps/Skeleton";
import Retry from "../../comps/RetryBlock";
import Tooltip from "./Tooltip";

import { useWoodprices } from "../context/Woodprices";
import { formatCompanyYAxisTick, measureMaxYAxisLabelWidth } from "../utils/chartYAxisWidth";

const colors = {
  one: '#059669',
  two: '#FBBF24',
}

export default function Pulpwood({ selectMuni }) {
  const { pulpwoodData, pulpwoodOptions, muni, fetchPulpwoodPrices } = useWoodprices();

  const data = useMemo(() => {
    return pulpwoodData?.prices?.map(c => {
      const names = { one: 'Prima', two: 'Sekunda' }
      const all = Object.entries(c[pulpwoodOptions.tree]).map(([key, val]) => ({
        value: key,
        price: val,
        label: names[key]
      }))

      return {
        company: c.name,
        price: Math.round(c[pulpwoodOptions.tree][pulpwoodOptions.quality]),
        all: all
      }
    }).sort((a, b) => b.price - a.price)
  }, [pulpwoodData, pulpwoodOptions])

  const yAxisWidth = useMemo(
    () => measureMaxYAxisLabelWidth(data?.map((d) => d.company)),
    [data]
  )

  if (!muni) {
    return selectMuni()
  } else if (pulpwoodData === null) {
    return <Retry func={() => fetchPulpwoodPrices()} />
  } else if (!pulpwoodData || pulpwoodData?.prices?.length === 0) {
    return <div className='flex flex-col flex-1 justif-between w-full gap-6 overflow-x-auto mb-4 p-4'>
      {Array.from({ length: 6 }, (_, index) => {
        return <Skeleton className={`h-[36px]`} style={{ width: `${8 - index}0%` }} />
      }
      )}
    </div>
  } else {
    return (
      <>
        <div className="flex flex-col space-y-3 px-4 relative">
          <BarChart
            barChart={{
              margin: { top: 0, right: 25, bottom: 0, left: 30 },
              layout: 'vertical',
              data: data,
            }}
            xAxis={{
              domain: [0, Math.ceil(pulpwoodData.highest / 200) * 200],
              interval: 0, tickFormatter: (value) => `${value} kr`,
              dataKey: "company",
              tick: { dy: 10 }
            }}
            yAxis={{
              width: yAxisWidth,
              tickFormatter: formatCompanyYAxisTick
            }}
            dataset={[
              {
                fill: colors[pulpwoodOptions.quality],
                dataKey: "price",
                maxBarSize: 36
              },
            ]}
            tooltip={<Tooltip />}
            size={{
              height: 330.6667,
              width: "100%",
            }}
          ></BarChart>
        </div>
      </>
    );
  }
}
